<template>
  <section class="operation-logs">
    <page-header title="操作日志审计" description="记录登录后的菜单访问、配置变更、运行操作和导出动作，支持按角色、结果和关键字回溯。">
      <template #actions><button class="btn" @click="load">刷新日志</button><button class="btn primary" @click="exportCsv">导出日志 CSV</button></template>
    </page-header>
    <operation-message :value="message" :type="isError ? 'error' : 'success'" @consumed="message = ''" />
    <div class="panel">
      <div class="filter-bar"><input v-model.trim="keyword" class="filter-input" placeholder="搜索姓名/模块/路径/账号"><select v-model="role" class="field"><option value="">全部角色</option><option value="ADMIN">管理员</option><option value="TEACHER">教师</option><option value="STUDENT">学生</option></select><select v-model="result" class="field"><option value="">全部结果</option><option value="SUCCESS">成功</option><option value="FAILED">失败</option></select><button class="btn" @click="load">查询</button></div>
      <div class="table-wrap">
        <table class="logs-table">
          <colgroup><col class="log-operator"><col class="log-role"><col class="log-module"><col class="log-request"><col class="log-result"><col><col class="log-time"></colgroup>
          <thead><tr><th>操作人</th><th>角色</th><th>操作模块</th><th>请求</th><th>结果</th><th>查询参数</th><th>操作时间</th></tr></thead>
          <tbody>
            <tr v-for="item in filtered" :key="item.id">
              <td class="log-nowrap" :title="item.operatorName || '未知用户'">{{ item.operatorName || '未知用户' }}</td>
              <td class="log-nowrap">{{ roleLabel(item.operatorRole || item.role) }}</td>
              <td class="log-nowrap" :title="item.operationModule || '系统操作'">{{ item.operationModule || '系统操作' }}</td>
              <td class="log-detail"><strong>{{ item.method || '—' }}</strong> <span class="muted">{{ item.path || item.action || '—' }}</span></td>
              <td class="log-nowrap"><status-tag :value="item.result || item.status" :label="resultLabel(item.result || item.status)"></status-tag><span class="muted"> {{ item.statusCode || '' }}</span></td>
              <td class="resource-content log-detail">{{ item.query || item.detail || '—' }}</td>
              <td class="log-nowrap">{{ formatTime(item.at || item.createdAt) }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!filtered.length" class="empty">暂无符合条件的操作日志</div>
      </div>
    </div>
  </section>
</template>

<script>
import { formatTime as displayTime } from '../services/display'
import { csvCell } from '../services/csv'
import PageHeader from '../components/PageHeader.vue'
import StatusTag from '../components/StatusTag.vue'
import { api, errorText } from '../services/api'
import { needsOperatorName, withOperatorNames } from '../services/auditLogNames'

export default {
  name: 'OperationLogs', components: { PageHeader, StatusTag },
  data () { return { items: [], keyword: '', role: '', result: '', message: '', isError: false } },
  computed: { filtered () { return this.items.filter(item => (!this.role || (item.operatorRole || item.role) === this.role) && (!this.result || (item.result || item.status) === this.result) && (!this.keyword || JSON.stringify(item).toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0)) } },
  created () { this.load() },
  methods: {
    async load () {
      try {
        const items = await api.list('/logs') || []
        let users = []
        if (items.some(needsOperatorName)) {
          // 新后端已补齐姓名时无需额外查询；旧接口则关联用户管理的实际姓名。
          try { users = await api.list('/users') || [] } catch (_) { /* 无用户查看权限时保留日志原信息 */ }
        }
        const current = this.$store.state.currentUser
        this.items = withOperatorNames(items, current ? [current, ...users] : users)
      } catch (error) { this.fail(error) }
    },
    roleLabel (value) { return { ADMIN: '管理员', TEACHER: '教师', STUDENT: '学生' }[value] || value || '—' },
    resultLabel (value) { return { SUCCESS: '成功', FAILED: '失败' }[value] || value || '—' },
    formatTime (value) { return displayTime(value) },
    exportCsv () {
      const headers = ['操作人', '角色', '操作模块', '方法', '路径', '结果', '状态码', '查询参数', '操作时间']
      const rows = this.filtered.map(item => [item.operatorName || '未知用户', this.roleLabel(item.operatorRole || item.role), item.operationModule || '系统操作', item.method, item.path || item.action, this.resultLabel(item.result || item.status), item.statusCode, item.query || item.detail, this.formatTime(item.at || item.createdAt)])
      const csv = [headers, ...rows].map(row => row.map(csvCell).join(',')).join('\r\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' })
      const url = URL.createObjectURL(blob); const link = document.createElement('a')
      link.href = url; link.download = '社区管理虚拟仿真沙盘-操作日志.csv'; link.click(); URL.revokeObjectURL(url)
      this.ok(`已导出 ${rows.length} 条日志`)
    },
    ok (message) { this.message = message; this.isError = false }, fail (error) { this.message = errorText(error); this.isError = true }
  }
}
</script>

